// import React from 'react';
import { MapPin, Phone, Mail, Linkedin, Facebook, Instagram, Youtube, Twitter } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';


const DeepBrikFooter = () => {
  return (
    <>
      <style>{`
        .footer {
          background-color: #0e2147;
          color: #fff;
          padding: 40px 20px 0px 20px;
          font-family: 'Segoe UI', Tahoma, Geneva, sans-serif;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .row {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: space-between;
        }

        .footer-column {
          flex: 1 1 22%;
          min-width: 200px;
        }

        .footer-section h3 {
          margin-bottom: 10px;
          font-size: 18px;
        }

        .footer-section ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-section ul li {
          margin-bottom: 8px;
        }

        .footer-section input[type="email"] {
          width: 100%;
          padding: 8px;
          margin-top: 10px;
          margin-bottom: 10px;
          border: none;
          border-radius: 4px;
        }

        .footer-section button {
          padding: 8px 12px;
          border: 2px solid white;
          background-color: #0e2147;
          color: white;
          border-radius: 4px;
          cursor: pointer;
        }

        .footer-section .social-media ul {
          display: flex;
          gap: 10px;
          padding: 0;
          margin: 0;
        }

        .footer-section .social-media ul li {
          font-size: 14px;
          color: #fff;
          background: #444;
          padding: 6px 10px;
          border-radius: 4px;
        }

        .footer-section .social-media ul li a {
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .bottom-bar {
          background-color: #0e2147;
          color: white;
          padding: 15px 40px;
          font-size: 14px;
          border-top: 1px solid rgba(255, 255, 255, 0.2);
        }

        .bottom-left {
          text-align: left;
          line-height: 2.2;
          max-width: 400px;
        }

        .bottom-right {
          display: none;
        }

        @media (min-width: 769px) {
          .bottom-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: nowrap;
          }

          .bottom-left {
            text-align: left;
          }

          .bottom-right {
            display: block;
            text-align: right;
          }

          .bottom-left a {
            display: inline-block;
            margin-left: -6px;
          }

          .bottom-right a {
            display: inline;
          }
        }

        .footer-link {
          color: white;
          text-decoration: none;
        }

        .footer-link:hover {
          text-decoration: underline;
        }

        /* WhatsApp Widget */
.whatsapp-widget {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
}

.whatsapp-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #25D366;
  color: white;
  font-size: 28px;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.whatsapp-button:hover {
  background-color: #128C7E;
  transform: scale(1.1);
}

/* Chatbot Widget */
.chatbot-widget {
  position: fixed;
  bottom: 24px;
  right: 96px; /* slightly left of WhatsApp */
  z-index: 999;
}

.chatbot-toggle {
  background-color: #0e2147;
  color: white;
  border: none;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.chatbot-toggle:hover {
  background-color: #1a3470;
  transform: scale(1.1);
}

.chatbot-iframe {
  position: fixed;
  bottom: 90px;
  right: 24px;
  width: 380px;
  height: 520px;
  border: none;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  display: none;
  z-index: 999;
}

.chatbot-iframe.open {
  display: block;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile adjustments */
@media (max-width: 768px) {
  /* WhatsApp */
  .whatsapp-widget {
    bottom: 16px;
    right: 16px;
  }

  .whatsapp-button {
    width: 48px;
    height: 48px;
    font-size: 24px;
  }

 /* Mobile adjustments for chatbot */
@media (max-width: 768px) {
  /* Chatbot widget position */
  .chatbot-widget {
    bottom: 16px;
    right: 80px; /* slightly left of WhatsApp */
  }

  /* Chatbot toggle button */
  .chatbot-toggle {
    width: 48px;
    height: 48px;
    font-size: 20px;

    /* Center the robot icon */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  /* Chatbot iframe */
  .chatbot-iframe {
    width: 90%; /* almost full width */
    max-width: 350px;
    height: 60vh; /* relative height */
    bottom: 70px;
    right: 50%;
    transform: translateX(50%);
  }

  /* Icon inside toggle */
  .chatbot-toggle i {
    font-size: 20px; /* adjust for smaller button */
    line-height: 1;
  }
}




      `}</style>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="footer-column">
              {/* Logo above Services */}
              <div className="oval-logo">
                <img src="/Images/fevi1.jpg" alt="Logo" style={{ height: "50px" }} />
              </div>
              <section className="footer-section">
                <h3><a href="/services" style={{ color: 'white', textDecoration: 'none' }}>Services</a></h3>
                <ul>
                  <li>AI &amp; Machine Learning Solutions</li>
                  <li>Data Analytics &amp; Business Intelligence</li>
                  <li>Web Application Development</li>
                  <li>Smart Traffic &amp; Mobility Intelligence</li>
                  <li>Document &amp; Image Intelligence</li>
                  <li>AI Consulting &amp; Strategy</li>
                  <li>Newsletter Intelligence &amp; Content Automation</li>
                  <li>Cloud &amp; DevOps for AI</li>
                </ul>
              </section>
            </div>
            <div className="footer-column">
              <section className="footer-section">
                <h3><a href="/" style={{ color: 'white', textDecoration: 'none' }}>Industries</a></h3>
                <ul>
                  <li>Education</li>
                  <li>Health Care</li>
                  <li>Retail & E-Commerce</li>
                  <li>Renewable Energy</li>
                  <li>All</li>
                </ul>
              </section>
            </div>
            <div className="footer-column">
              <section className="footer-section">
                <h3>Platforms</h3>
                <ul>
                  <li>Microsoft Services</li>
                  <li>AWS</li>
                  <li>Google Cloud</li>
                  <li>WordPress</li>
                  <li>Magento</li>
                  <li>Office 365 & Teams</li>
                </ul>
              </section>
            </div>
            <div className="footer-column">
              <section className="footer-section">
                <h3>Subscribe To Our Newsletter</h3>
                <p>To get the latest news and updates.</p>
                <form>
                  <input type="email" placeholder="Email Address" />
                  <button type="submit">SUBSCRIBE</button>
                </form>
              </section>
              <section className="footer-section social-media" style={{ marginTop: '20px' }}>
                <ul style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                  <li><a href="https://www.linkedin.com/company/107495025/admin/page-posts/published/"><Linkedin className="w-5 h-5" color="white" /></a></li>
                  <li><a href="https://x.com/deepbrik?s=11"><Twitter className="w-5 h-5" color="white" /></a></li>
                  <li><a href="https://x.com/deepbrik?s=11"><Facebook className="w-5 h-5" color="white" /></a></li>
                  <li><a href="https://www.instagram.com/deepbrik?igsh=M2R3M2lkaDAzZ3pw&utm_source=qr"><Instagram className="w-5 h-5" color="white" /></a></li>
                  <li><a href="https://youtu.be/AU-hc8_z0SI"><Youtube className="w-5 h-5" color="white" /></a></li>
                </ul>
              </section>
            </div>
            <div className="footer-column">
              <section className="footer-section">
                <h3>Contact Us</h3>
                <p><Mail className="inline-block mr-2" /> Email: support@deepbrik.com</p>
                <p><Phone className="inline-block mr-2" /> Phone: +91 6361799717</p>
                <p><MapPin className="inline-block mr-2" /> Address: Bangalore, Karnataka</p>
              </section>
            </div>
          </div>
        </div>
      </footer>

      {/* Copyright */}
      <div className="bottom-bar">
        <div className="bottom-left">
          <div><a href="#" className="footer-link">Terms and Service</a></div>
          <div><a href="#" className="footer-link">Privacy Policy</a></div>
          <div>Copyrights © 2025 Deepbrik All rights reserved</div>
        </div>
      </div>

      {/* WhatsApp Chat Button */}
<div className="whatsapp-widget">
  <a
    href="https://wa.me/+916361799717"
    className="whatsapp-button"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
  >
    <FaWhatsapp />
  </a>
</div>
{/* AI Chatbot Widget */}
<div className="chatbot-widget">
  <button
    className="chatbot-toggle"
    onClick={() => {
      const iframe = document.querySelector('.chatbot-iframe');
      iframe.classList.toggle('open');
    }}
  >
    💬
  </button>
  <iframe
    src="https://deep-insight-creations.vercel.app/"
    title="DeepBrik AI Chat"
    className="chatbot-iframe"
  ></iframe>
</div>

</>
  );
};

export default DeepBrikFooter;
